import { ERFElement } from '../../../enums';
export const FLOW_MATERIAL_CONFIG = {
    type: ERFElement.FlowMaterial,
    icon: 'MaterialFlow',
    templates: []
};
//# sourceMappingURL=RFFlowMaterialNode.config.js.map